<template>
    <teleport v-if="loaded" to="#info-sidebar">
        <div v-if="infoSidebarOpen">
            <slot name="info">
            </slot>
        </div>
    </teleport>
</template>
<script>
export default {
    data() {
        return {
            loaded: false,
        };
    },

    computed: {
        infoSidebarOpen() {
            return this.$sidebar('isOpen');
        },
    },

    mounted() {
        this.$nextTick(() => {
            this.loaded = true;
        });
    }
}
</script>
